/**
 * Reservation model — from GET/PATCH reservation APIs (owner) and POST (public).
 * Uses uuid only; no internal id. See docs/API-REFERENCE.md Table reservations.
 */

export default class Reservation {
  constructor(data = {}) {
    this._uuid = data.uuid ?? null
    this._pax = data.pax ?? data.booking_pax ?? 0
    this._bookingDate = data.booking_date ?? data.date ?? ''
    this._bookingTime = data.booking_time ?? data.time ?? ''
    this._customerName = data.customer_name ?? ''
    this._customerMobile = data.customer_mobile ?? ''
    this._status = data.status ?? 'pending'
    this._reminderSentAt = data.reminder_sent_at ?? null
    this._createdAt = data.created_at ?? null
  }

  get uuid() {
    return this._uuid
  }

  get pax() {
    return this._pax
  }

  get booking_date() {
    return this._bookingDate
  }

  get booking_time() {
    return this._bookingTime
  }

  get customer_name() {
    return this._customerName
  }

  get customer_mobile() {
    return this._customerMobile
  }

  get status() {
    return this._status
  }

  get reminder_sent_at() {
    return this._reminderSentAt
  }

  get created_at() {
    return this._createdAt
  }

  /** Build from API response (list item or single). */
  static fromApi(apiData) {
    const data = apiData?.data ?? apiData
    return new Reservation(data ?? {})
  }

  toJSON() {
    return {
      uuid: this._uuid,
      pax: this._pax,
      booking_date: this._bookingDate,
      booking_time: this._bookingTime,
      customer_name: this._customerName,
      customer_mobile: this._customerMobile,
      status: this._status,
      reminder_sent_at: this._reminderSentAt,
      created_at: this._createdAt,
    }
  }
}
